import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { baseTheme } from '~base-theme';
var Container = styled.span.withConfig({
  displayName: "Container",
  componentId: "sc-1ees1yc-0"
})(["align-items:center;display:flex;flex-direction:column;justify-content:center;", " ", ""], function (_ref) {
  var isFullScreen = _ref.isFullScreen;
  return isFullScreen && css(["background-color:", ";height:100%;left:0;position:fixed;top:0;width:100%;z-index:1;"], function (_ref2) {
    var theme = _ref2.theme;
    return _get(theme, 'base.colors.light', baseTheme.base.colors.light);
  });
}, function (_ref3) {
  var size = _ref3.size;
  return size && css(["font-size:", ";"], rem(size));
});
export default Container;